<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Autres">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; La pharmacie a-t-elle une activité de commerce
                électronique ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.commerceElectronique"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="commerceElectronique"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="commerceElectronique"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; La pharmacie est-t-elle présente sur les réseaux sociaux
                ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.reseauxSociaux"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="reseauxSociaux"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="reseauxSociaux"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; La pharmacie est-elle automatisée ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.automatise"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="automatise"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="automatise"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; La pharmacie dispose-t-elle d’un espace de
                télé-consultation ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.teleconsultation"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="teleconsultation"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="teleconsultation"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.plageHoraire"
                label="Plages horaires d’ouverture"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import moment from "moment";

export default {
  name: "Partie13",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    menu: false,
    dateFormationEtp: null,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"],
    numberRules: [
      v =>
        /^-?([0-9]\d*\.?\d*)$/.test(v) ||
        "La superficie doit être composée uniquement de chiffres"
    ]
  }),
  computed: {
    formatedDate() {
      return this.dateFormationEtp
        ? moment(this.dateFormationEtp).format("DD/MM/YYYY")
        : "";
    }
  },
  created() {
    if (this.dossier.dateFormationEtp) {
      let unix_timestamp = this.dossier.dateFormationEtp;
      var date = new Date(unix_timestamp);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.dateFormationEtp = year + "-" + month + "-" + day;
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.dossier.dateFormationEtp = this.dateFormationEtp;
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
